import { useMutation } from "@tanstack/react-query";
import { useRefreshAlgoliaData } from "entities/algolia/hooks/useRefreshAlgoliaData";
import { updateDynamicTranslations } from "../api/updateDynamicTranslations";
import { UpdatedTranslations } from "../types";

const INITIAL_DELAY_MS = 2000;
const REFRESH_INTERVAL_MS = 5000;

export const useDynamicTranslationsMutation = () => {
  const { refreshAlgoliaData } = useRefreshAlgoliaData();

  return useMutation({
    mutationFn: async (updatedTranslations: UpdatedTranslations) => {
      return updateDynamicTranslations(updatedTranslations);
    },
    onSuccess: () => {
      // Invalidate query and refetch Algolia
      refreshAlgoliaData(INITIAL_DELAY_MS);
      refreshAlgoliaData(REFRESH_INTERVAL_MS);
    },
    onError: (e) => {
      console.error("Error occurred when updating static translations", e);
    },
  });
};
